export default [
  {
    title: '营销主题标签',
    key: 'typeLabelName'
  },
  {
    title: '时间',
    key: 'timeRange'
  },
  {
    title: '实际消耗占比',
    key: 'consumePercent'
  },
  {
    title: '实际消耗金额',
    key: 'amount'
  }
]
